import React, { useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";
import { addExchangeBet, getBookMakerMarkets } from "../../store";
import "./BMTable.scss";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import moment from "moment";
import Betslip from "../BetSlip/BetSlip";
// import Modal from '@material-ui/core/Modal';
import { BsData } from "../../models/BsData";
import MarketOddBtn from "../OddButton/MarketOddBtn";
import {
  BookMakers,
  EventData,
  Runners,
  MatchOddsRunnerDTO,
} from "../../models/EventData";
import { UserBet } from "../../models/UserBet";
import { marketNameMap } from "../../constants/common-utlits";

type StoreProps = {
  bets: BsData[];
  addExchangeBet: (data) => void;
  eventData: EventData;
  bmMarkets: BookMakers[];
  openBetsData: UserBet[];
};

const BMTable: React.FC<StoreProps> = (props) => {
  const { bets, addExchangeBet, eventData, bmMarkets, openBetsData } = props;
  const [selectedRow, setSelectedRow] = useState<string>("");
  const disabledStatus = ["suspended", "closed", "suspended-manually"];
  let operatorId = sessionStorage.getItem("psOperatorId");

  const tableFields = [
    {
      key: "teamName",
      Label: "Market",
      className: "market-name-cell-head",
      align: "left",
    },
    {
      key: "Back",
      Label: "Back" + (operatorId === "MPC1" ? " (L)" : ""),
      className: "odds-cell-head",
      align: "center",
    },
    {
      key: "Lay",
      Label: "Lay" + (operatorId === "MPC1" ? " (K)" : ""),
      className: "odds-cell-head",
      align: "center",
    },
  ];

  const getOpenBetsPL = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    let returns = null;

    const mOpenBets = openBetsData.filter((b) => b.marketName === marketName);
    for (let bet of mOpenBets) {
      const plVal =
        (bet.oddValue / 100 + 1) * bet.stakeAmount - bet.stakeAmount;
      if (bet.betType === "BACK") {
        if (bet.runnerId === runner.runnerId) {
          returns ? (returns += plVal) : (returns = plVal);
        } else {
          returns
            ? (returns -= bet.stakeAmount)
            : (returns = 0 - bet.stakeAmount);
        }
      } else if (bet.betType === "LAY") {
        if (bet.runnerId !== runner.runnerId) {
          returns ? (returns += bet.stakeAmount) : (returns = bet.stakeAmount);
        } else {
          returns ? (returns -= plVal) : (returns = 0 - plVal);
        }
      }
    }
    const retVal = returns ? returns : null;
    return retVal;
  };

  const getOpenBetsPLInArray = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    return [getOpenBetsPL(marketId, marketName, runner)];
  };
  const getTotalPL = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    let returns = null;
    const mBetslipBets = bets.filter(
      (b) => b.marketId === marketId && b.stakeAmount && b.stakeAmount > 0
    );
    if (mBetslipBets.length > 0) {
      returns = getOpenBetsPL(marketId, marketName, runner);
      for (let bet of mBetslipBets) {
        const plVal =
          (bet.oddValue / 100 + 1) * bet.stakeAmount - bet.stakeAmount;
        if (bet.betType === "BACK") {
          if (bet.runnerId === runner.runnerId)
            returns ? (returns += plVal) : (returns = plVal);
          else
            returns
              ? (returns -= bet.stakeAmount)
              : (returns = 0 - bet.stakeAmount);
        } else if (bet.betType === "LAY") {
          if (bet.runnerId === runner.runnerId)
            returns ? (returns -= plVal) : (returns = 0 - plVal);
          else
            returns
              ? (returns += bet.stakeAmount)
              : (returns = bet.stakeAmount);
        }
      }
    }
    return [returns];
  };

  return (
    <>
      <div className="bm-table-ctn">
        <div className="bm-table-content table-ctn">
          {bmMarkets && bmMarkets?.length > 0
            ? bmMarkets.map((market, index) => {
                return (
                  <>
                    <TableContainer key={index} component={Paper}>
                      <Table className="bm-table">
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={3}>
                              <div className="market-name-cell-head-ctn">
                                <div className="market">
                                  {operatorId === "MPC1"
                                    ? marketNameMap[market.marketName]
                                    : market.marketName}
                                </div>
                                <div className="limit">
                                  Min :
                                  {market?.limits?.minBetValue
                                    ? " " + market?.limits?.minBetValue
                                    : " N/A"}
                                  {"   "}
                                  {"  "}
                                  <span></span>
                                  Max :
                                  {market?.limits?.maxBetValue
                                    ? market?.limits?.maxBetValue
                                    : "N/A"}
                                </div>{" "}
                              </div>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow className="header-row">
                            {tableFields.map((tF, index) => (
                              <TableCell
                                key={tF.key + index}
                                align={
                                  tF.align === "left"
                                    ? "left"
                                    : tF.align === "right"
                                    ? "right"
                                    : "center"
                                }
                                colSpan={1}
                                className={tF.className}
                              >
                                {tF.key === "lay" || "back" ? (
                                  <div
                                    className={tF.key.toLowerCase() + "-odd"}
                                  >
                                    {tF.Label}
                                  </div>
                                ) : (
                                  tF.Label
                                )}
                              </TableCell>
                            ))}
                          </TableRow>
                          {market.runners?.length > 0 ? (
                            <>
                              {market.runners.map((runner) => (
                                <BmOddsRow
                                  market={market}
                                  runner={runner}
                                  addExchangeBet={addExchangeBet}
                                  disabledStatus={disabledStatus}
                                  eventData={eventData}
                                  marketName={market.marketName}
                                  marketId={market.marketId}
                                  bets={bets}
                                  selectedRow={selectedRow}
                                  setSelectedRow={setSelectedRow}
                                  getOpenBetsPL={getOpenBetsPLInArray}
                                  getTotalPL={getTotalPL}
                                  index={index}
                                  min={
                                    market?.limits?.minBetValue
                                      ? market?.limits?.minBetValue
                                      : 0
                                  }
                                  max={
                                    market?.limits?.maxBetValue
                                      ? market?.limits?.maxBetValue
                                      : 0
                                  }
                                />
                              ))}
                            </>
                          ) : (
                            <>
                              <TableRow>
                                <TableCell colSpan={3}>
                                  <div className="fm-table-msg-text">
                                    No Match Odds for this event
                                  </div>
                                </TableCell>
                              </TableRow>
                            </>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                );
              })
            : null}
        </div>
      </div>
    </>
  );
};

type MatchOddsRowProps = {
  marketId: string;
  runner: Runners;
  disabledStatus: string[];
  bets: BsData[];
  addExchangeBet: (data) => void;
  eventData: EventData;
  marketName: string;
  selectedRow: string;
  setSelectedRow: (data) => void;
  getOpenBetsPL: (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO,
    type: string
  ) => number[];
  getTotalPL: (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => number[];
  index: number;
  min: number;
  max: number;
  market: BookMakers;
};

const BmOddsRow: React.FC<MatchOddsRowProps> = (props) => {
  const {
    marketId,
    runner,
    addExchangeBet,
    disabledStatus,
    eventData,
    marketName,
    bets,
    selectedRow,
    setSelectedRow,
    getOpenBetsPL,
    getTotalPL,
    index,
    min,
    max,
    market,
  } = props;

  return (
    <>
      <TableRow>
        <TableCell className="team-name-cell">
          <div className="team">{runner.runnerName}</div>
          <div className="risk-ctn">
            <div>
              {getOpenBetsPL(marketId, marketName, runner, "array").map((ret) =>
                ret !== null ? (
                  <span className={ret >= 0 ? "profit" : "loss"}>
                    {ret > 0
                      ? "+" + Number(ret).toFixed(2)
                      : Number(ret).toFixed(2)}
                  </span>
                ) : null
              )}
            </div>
            <div>
              {getTotalPL(marketId, marketName, runner).map((ret) =>
                ret !== null ? (
                  <span className={ret >= 0 ? "profit" : "loss"}>
                    {ret > 0
                      ? "+" + Number(ret).toFixed(2)
                      : Number(ret).toFixed(2)}
                  </span>
                ) : null
              )}
            </div>
          </div>
        </TableCell>
        <TableCell className="odds-cell">
          <div className="odds-block">
            <MarketOddBtn
              mainValue={
                runner.backPrices && runner.backPrices[0]
                  ? runner.backPrices[0].price
                  : 0
              }
              subValue={
                runner.backPrices && runner.backPrices[0]
                  ? runner.backPrices[0].size
                  : 0
              }
              showSubValueinKformat={true}
              oddType="back-odd"
              valueType="matchOdds"
              disable={
                disabledStatus.includes(eventData.status.toLowerCase()) ||
                disabledStatus.includes(market.status.toLowerCase()) ||
                disabledStatus.includes(runner.status.toLowerCase())
              }
              onClick={() => {
                addExchangeBet({
                  eventId: eventData.eventId,
                  eventName: eventData.eventName,
                  marketId: marketId,
                  marketName: marketName,
                  marketType: "BOOKMAKER",
                  oddValue:
                    runner.backPrices && runner.backPrices[0]
                      ? runner.backPrices[0].price
                      : 0,
                  betType: "BACK",
                  stakeAmount: 0,
                  runnerId: runner.runnerId,
                  runnerName: runner.runnerName,
                  competitionId: eventData.competitionId,
                  sportId: eventData.sportId,
                  maxLimit: max,
                  minLimit: min,
                });
                setSelectedRow(runner.runnerId + marketName + "BOOKMAKER");
              }}
            />
          </div>
        </TableCell>
        <TableCell className="odds-cell">
          <div className="odds-block">
            <MarketOddBtn
              mainValue={
                runner.layPrices && runner.layPrices[0]
                  ? runner.layPrices[0].price
                  : 0
              }
              subValue={
                runner.layPrices && runner.layPrices[0]
                  ? runner.layPrices[0].size
                  : 0
              }
              showSubValueinKformat={true}
              oddType="lay-odd"
              valueType="matchOdds"
              disable={
                disabledStatus.includes(eventData.status.toLowerCase()) ||
                disabledStatus.includes(market.status.toLowerCase()) ||
                disabledStatus.includes(runner.status.toLowerCase())
              }
              onClick={() => {
                addExchangeBet({
                  eventId: eventData.eventId,
                  eventName: eventData.eventName,
                  marketId: marketId,
                  marketType: "BOOKMAKER",
                  marketName: marketName,
                  oddValue:
                    runner.layPrices && runner.layPrices[0]
                      ? runner.layPrices[0].price
                      : 0,
                  betType: "LAY",
                  stakeAmount: 0,
                  runnerId: runner.runnerId,
                  runnerName: runner.runnerName,
                  competitionId: eventData.competitionId,
                  sportId: eventData.sportId,
                  maxLimit: max,
                  minLimit: min,
                });

                setSelectedRow(runner.runnerId + marketName + "BOOKMAKER");
              }}
            />
          </div>
        </TableCell>
      </TableRow>

      {bets.length > 0 &&
      selectedRow === runner.runnerId + bets[0].marketName + "BOOKMAKER" ? (
        <TableRow className="mob-view">
          <TableCell colSpan={3}>
            {" "}
            <Betslip page={"market"} />{" "}
          </TableCell>
        </TableRow>
      ) : null}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    bets: state.betslip.bets,
    eventData: state.sportsBook.eventInfo,
    bmMarkets: getBookMakerMarkets(state.sportsBook.eventInfo),
    openBetsData: state.betslip.openBets,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: BsData) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BMTable);
